export const BUY = "Compra";
export const SELL = "Venda";
